/**
 * Figurine gallery — client-side filter + click-to-select into the builder.
 *
 * The grid is server-rendered by Bridge (GET /quick-view/figurine-gallery) into
 * #figurineGalleryBody, so this file has NO transport of its own:
 *
 *  1. Filters the tiles by the `keywords` attribute Bridge stamps on each
 *     .figurine-gallery-item (group + style + sku); a group section hides when
 *     none of its tiles match.
 *  2. A tile click selects that figurine in the product options. The Figurine
 *     attribute is a grouped two-step dropdown (group select, then a style
 *     select that only exists after a re-render), so instead of driving both
 *     dropdowns in turn this posts BOTH values in the one builder re-render the
 *     style select's own change would trigger: set the group select, inject a
 *     hidden style input, then fire button.btn-builder with the same
 *     ?builder=true&sku&step&is_group=0 link the templates' change handler
 *     builds (collection.product-group.liquid / product.liquid). Bridge then
 *     renders group + style selected, enables the next step and recomputes
 *     price/composite exactly as after two manual picks.
 *
 * Delegated because everything is injected into the modal after load.
 */
window.myjQuery(document).ready(function ($) {

  $('body').on('input', '.figurine-gallery-search', function () {

    var term = $(this).val().trim().toLowerCase();
    var $gallery = $(this).closest('.figurine-gallery');
    var anyVisible = false;

    $gallery.find('.figurine-gallery-item').each(function () {
      var keywords = ($(this).attr('keywords') || '').toLowerCase();
      var match = !term.length || keywords.indexOf(term) !== -1;
      $(this).toggle(match);
      if (match) {
        anyVisible = true;
      }
    });

    $gallery.find('.figurine-gallery-section').each(function () {
      $(this).toggle($(this).find('.figurine-gallery-item:visible').length > 0);
    });

    $gallery.find('.figurine-gallery-noresults').toggle(!anyVisible);
  });

  $('body').on('click', '#figurineGalleryBody .figurine-gallery-select', function () {

    // .attr() not .data(): jQuery .data() would coerce a numeric-looking group
    // or sku ("2024") into a number, and the group must match its <option> text.
    var sku = $(this).attr('data-sku');
    var attribute = $(this).attr('data-attribute');
    var group = $(this).attr('data-group');
    var value = $(this).attr('data-value');

    var $form = $('form#builders');
    var styleName = 'builders[' + sku + '][attributes][' + attribute + ']';
    var $group = $form.find('select[name="builders[' + sku + '][attributes][group_' + attribute + ']"]');

    if (!$group.length) {
      return;
    }

    $group.val(group);

    // Replace whatever holds the style today (the style select from an earlier
    // pick, or a hidden input from an earlier gallery click). The re-render
    // rebuilds the real select with this value selected.
    $form.find('[name="' + styleName + '"]').remove();
    $('<input type="hidden">').attr('name', styleName).val(value).appendTo($form);

    // Same link the templates' .builder-dropdown change handler builds for the
    // style select: is_group=0 so the NEXT step is enabled after this render.
    var link = $group.data('link') + '?builder=true&sku=' + sku + '&step=' + $group.data('step') + '&is_group=0';

    // Group pages need category_id (grouped() does Category::find); the
    // template appends it from Liquid, we read it off the options loader link.
    var loader = String($('.btn-get-options').data('link') || '');
    var category = loader.match(/[?&]category_id=(\d+)/);
    if (category) {
      link += '&category_id=' + category[1];
    }

    var $submit = $('button.btn-builder');
    $submit.data('link', link);
    $submit.data('show', '.spinner-dropdown-' + attribute + '-' + sku + '-group');

    $('#figurineGalleryModal').modal('hide');
    $submit.click();
  });

});
